import httpPortal from './http-portal'

class Report {
  download (jobId) {
    return httpPortal.get(`/private/api/v1/report/download/${jobId}`)
  }
}

export default new Report()



// WEBPACK FOOTER //
// ./src/services/report.js